import { render, staticRenderFns } from "./NumberSetting.vue?vue&type=template&id=c80bab50&scoped=true&"
import script from "./NumberSetting.vue?vue&type=script&lang=js&"
export * from "./NumberSetting.vue?vue&type=script&lang=js&"
import style0 from "./NumberSetting.vue?vue&type=style&index=0&id=c80bab50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80bab50",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VIcon,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c80bab50')) {
      api.createRecord('c80bab50', component.options)
    } else {
      api.reload('c80bab50', component.options)
    }
    module.hot.accept("./NumberSetting.vue?vue&type=template&id=c80bab50&scoped=true&", function () {
      api.rerender('c80bab50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Settings/NumberSetting.vue"
export default component.exports